import * as React from 'react'
import {ReactNode} from 'react'
import {cn} from "../lib/fns";

function Table({className, ...props}: React.ComponentProps<'table'>) {
  return (<table
    data-slot="table"
    className={cn('min-w-full w-max text-xs table-fixed', className)}
    {...props}
  />)
}

function TableHeader({className, ...props}: React.ComponentProps<'thead'>) {
  return (<thead
    data-slot="table-header"
    className={cn("bg-white-f5 sticky top-0 z-10", className)}
    {...props}
  />)
}

function TableBody({className, ...props}: React.ComponentProps<'tbody'>) {
  return (<tbody
    data-slot="table-body"
    className={className}
    {...props}
  />)
}

function TableRow({className, onClick, ...props}: React.ComponentProps<'tr'>) {
  return (<tr
    data-slot="table-row"
    className={cn('group h-8 grid min-w-full w-max data-[state=selected]:bg-accent transition-colors border-b', onClick && 'hover:bg-accent', className,)}
    onClick={onClick}
    {...props}
  />)
}

function TableHead({className, ...props}: React.ComponentProps<'th'>) {
  return (<th
    data-slot="table-head"
    className={cn('h-full px-2 text-xs text-center align-middle grid justify-center items-center font-bold text-black whitespace-nowrap [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]', className,)}
    {...props}
  />)
}

function TableCell({className, ...props}: React.ComponentProps<'td'>) {
  return (<td
    data-slot="table-cell"
    className={cn('h-full w-full text-xs text-center overflow-hidden align-middle grid justify-center items-center whitespace-normal text-ellipsis [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]', className,)}
    {...props}
  />)
}

function TableResult({children = "Loading...", type = "loading"}: {
  children?: ReactNode,
  type?: "loading" | "error"
}) {
  return (<div className={cn("min-h-32 flex items-center justify-center text-sm", type === "error" ? "text-danger" : "text-black/45")}>
    {children}
  </div>);
}

export {
  Table, TableHeader, TableBody, TableHead, TableRow, TableCell, TableResult
}
